import { useEffect, useState } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { showError } from "./utils/utils";
import { rawFileAtom, messagesAtom } from "./constant/global";
import DragAndDrop from "./components/DragAndDrop/DragAndDrop";
import MessageViewer from "./components/MessageViewer/MessageViewer";
import Sidebar from "./components/Sidebar/Sidebar";
import * as Style from "./style";
import exampleChat from "./assets/whatsapp-chat-parser-example.zip";
import { Route, Routes } from "react-router-dom";
import Header from "./pages/Header";
import { useSearchParams } from "react-router-dom";
import ResetPassWord from "./pages/ResetPassWord";
import { toast } from "react-toastify";

function App() {
  const messages = useAtomValue(messagesAtom);
  const setRawFile = useSetAtom(rawFileAtom);
  const [loginUser, setLoginUser] = useState(false);
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get("token");
  const msg = searchParams.get("msg");

  useEffect(() => {
    if (msg) {
      toast.success("Email verified successfully.");
    }
  }, [msg]);

  useEffect(() => {
    const data = localStorage.getItem("user");

    if (data) {
      const parsedData = JSON.parse(data);
      if (parsedData.token) {
        setLoginUser(true);
      } else {
        setLoginUser(false);
      }
    } else {
      setLoginUser(false);
    }
  }, []);

  const processFile = (file) => {
    if (!file || !loginUser) return;

    const reader = new FileReader();

    reader.addEventListener("loadend", (e) => {
      if (e.target) {
        setRawFile(e.target.result);
      }
    });

    if (/^application\/(?:x-)?zip(?:-compressed)?$/.test(file.type)) {
      reader.readAsArrayBuffer(file);
    } else if (file.type === "text/plain") {
      reader.readAsText(file);
    } else {
      showError(`File type ${file.type} not supported`);
    }
  };

  useEffect(() => {
    const keyHandler = (e) =>
      document.documentElement.classList.toggle("ctrl-down", e.ctrlKey);

    document.addEventListener("keydown", keyHandler);
    document.addEventListener("keyup", keyHandler);

    return () => {
      document.removeEventListener("keydown", keyHandler);
      document.removeEventListener("keyup", keyHandler);
    };
  }, []);

  const handleLinkClick = (e) => {
    if (!loginUser) {
      e.preventDefault();
    }
  };

  return (
    <>
      <Style.GlobalStyles />
      <Style.Main>
        <Style.Container>
          <Routes>
            <Route
              path="/"
              element={
                resetToken ? (
                  <ResetPassWord token={resetToken} />
                ) : (
                  <Header setLoginUser={setLoginUser} />
                )
              }
            />
          </Routes>
        </Style.Container>
        <Style.DragAndDropSection>
          <Style.Header>
            <DragAndDrop
              onFileUpload={processFile}
              id="dropzone"
              disabled={loginUser}
            />
            <span>OR</span>
            <a
              href={exampleChat}
              download
              onClick={handleLinkClick}
              className={!loginUser ? Style.disabledLink : ""}
              style={!loginUser ? { pointerEvents: "none", opacity: 0.5 } : {}}
            >
              Download example chat
            </a>
          </Style.Header>
          <MessageViewer />
          {messages.length > 0 && <Sidebar />}
        </Style.DragAndDropSection>
      </Style.Main>
    </>
  );
}

export default App;
